export default __webpack_public_path__ + "static/media/buttonbg.a4a5aa4e.png";